import { render } from "./EditClient.vue?vue&type=template&id=a81af0ea&ts=true"
import script from "./EditClient.vue?vue&type=script&lang=ts"
export * from "./EditClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__